export const SIDE = ['px', 'nx', 'py', 'ny', 'pz', 'nz'];
